import { mergeWith } from 'ramda'
import {
  ChannelSettings,
  OperationSettings
} from './use-persisted-channel-settings'

export const KEY_STORAGE = 'moises:track-settings'

export const mergeDefined = mergeWith((a, b) => b ?? a)

const diffObjects = (obj1: any, obj2: any): any => {
  if (!obj1 || !obj2) return {}

  const changes: any = {}

  Object.keys(obj1).forEach((key) => {
    if (
      Object.prototype.hasOwnProperty.call(obj1, key) &&
      Object.prototype.hasOwnProperty.call(obj2, key)
    ) {
      if (obj1[key] !== obj2[key]) {
        changes[key] = obj2[key]
      }
    }
  })

  return changes
}

const getStateMetronome = (
  channelsOldState?: ChannelSettings[],
  channelsNewState?: ChannelSettings[],
  lastFeatureInteracted?: string
): {
  showMetronome: boolean
} => {
  const metronomeOnNewState = channelsNewState?.filter(
    (i) => i.id.includes('metronome') && !i.isMuted
  )?.[0]

  if (!metronomeOnNewState) {
    return {
      showMetronome: false
    }
  }

  const { id } = metronomeOnNewState
  const diffMetronome = diffObjects(
    channelsOldState?.filter((i) => i.id === id)?.[0],
    channelsNewState?.filter((i) => i.id === id)?.[0]
  )

  if (
    Object.keys(diffMetronome).length > 0 ||
    lastFeatureInteracted === 'showMetronome'
  ) {
    return {
      showMetronome: true
    }
  }

  return {
    showMetronome: false
  }
}

export const getLastFeatureInteracted = (
  oldState?: OperationSettings,
  newState?: Omit<OperationSettings, 'type'>
): string | undefined => {
  const diffStates = {
    ...diffObjects(oldState?.panels, newState?.panels),
    ...getStateMetronome(
      oldState?.channels,
      newState?.channels,
      oldState?.general?.lastFeatureInteracted
    )
  }
  const trueProperty = Object.entries(diffStates).find(
    ([, value]) => value === true
  )?.[0]

  // return panel interacted if it is true
  if (trueProperty) {
    return trueProperty
  }

  // return undefined if no has lastFeatureInteracted
  const currentLastFeatureInteracted = oldState?.general?.lastFeatureInteracted
  if (!currentLastFeatureInteracted) {
    return undefined
  }

  // verify if currentLastFeatureInteracted is not false on new state
  const hasCurrentPropertyOnDiffPanels = Object.prototype.hasOwnProperty.call(
    diffStates,
    currentLastFeatureInteracted
  )
  const isFalsePropertyOnDiffPanels =
    diffStates[currentLastFeatureInteracted] === false

  if (hasCurrentPropertyOnDiffPanels && isFalsePropertyOnDiffPanels) {
    return undefined
  }

  // return currentLastFeatureInteracted if it is not false
  return currentLastFeatureInteracted
}
